import { styled } from "/stitches.config.js";
import Image from "next/image";

export default function MobileOnly() {
  return (
    <MobileOverlay>
      <Image alt="instashot" width="141" height="30" src="/logo.png" />
      <p>Packshot generator is currently not supported on mobile devices.</p>
      <p style={{ color: "#6B7280" }}>
        Launch{" "}
        <span style={{ color: "#7B61FF", textDecoration: "underline" }}>
          https://instashot.xyz/packshot
        </span>{" "}
        on your desktop computer.
      </p>
      <Image alt="" width="398" height="315" src="/packshot-screenshot.png" />
    </MobileOverlay>
  );
}

const MobileOverlay = styled("div", {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "black",
  color: "white",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "20px",
  lineHeight: "28px",
  gap: 30,
  p: {
    margin: "0px 30px",
  },
});
